import { defaultColors } from "../config";
import tinycolor from "tinycolor2";

const setBrandColors = (brandColors) => {
  Object.keys(brandColors).forEach((key) => {
    document.documentElement.style.setProperty(`--${key}`, brandColors[key]);
  });
};

export const calculateBrandColors = (brand_color) => {
  let newColors = {};

  if (brand_color !== "#000" && brand_color !== "#000000") {
    const defaultBrandColor = tinycolor(defaultColors.companyColor);
    const brandColor = tinycolor(brand_color);
    const brandColorHsl = brandColor.toHsl();

    let lumiDiff =
      brandColor.getLuminance() - defaultBrandColor.getLuminance() * 100;

    Object.keys(defaultColors).forEach((key) => {
      if (key !== "companyColor") {
        const dc = tinycolor(defaultColors[key]).lighten(lumiDiff).toHsl();

        const newLightness = dc.l + brandColorHsl.l;

        const newHsl = {
          h: brandColorHsl.h,
          s: brandColorHsl.s,
          l: newLightness > 1 ? dc.l : newLightness,
        };

        if (key === "subTextColorOnCompanyColor") {
          //add extra contrast to this text
          newHsl.l = 1;
        }

        if (key === "companyText") {
          if (newHsl.l > 0.2) {
            newHsl.l = 0.2;
          }
        }

        newColors[key] = tinycolor(newHsl).toHexString();
      } else {
        newColors[key] = brand_color;
      }
    });
  } else {
    newColors = defaultColors;
  }

  setBrandColors(newColors);
};
